import React from 'react';
import { connect } from 'react-redux';
import { awsCusData } from '../store/customerAction';
import { Result, Button, Spin, Typography, Layout } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import ClientHeader from '../components/header';
import ClientFooter from '../components/footer';
import withRouter from '../components/withRouter';
import axios from 'axios'; 

const { Title } = Typography;

class LandingPage extends React.Component {
  state = {
    status: 'loading',
    message: 'Verifying your subscription information, please wait...',
  };

  componentDidMount() {
    this.verification();
  }

  async verification() {
    try {
      console.log('開始驗證訂閱...');
      // const params = new URLSearchParams(this.props.location.search);
      const params = new URLSearchParams(window.location.search);
      console.log('🪪 location.search:', window.location.search);
      const token = params.get('x-amzn-marketplace-token');
      console.log('AWS Marketplace Token:', token);
      if (!token) {
        throw new Error('Not Found AWS Marketplace Token');
      }
      
      // For local 測試可以用這組token
      // const mock_token =
      //   'MARxQUYUgJwqgt';

      // if (!mock_token) {
      //   throw new Error('未找到 AWS Marketplace Token');
      // }
      
      this.setState({ message: 'Connecting to the server to verify your subscription...' });
      
      const response = await axios.post(
        // 'https://backend-1075612823060.asia-east1.run.app/marketplace/subscription',
        // 'http://localhost:8080/marketplace/subscription',
        process.env.REACT_APP_API_URL + '/user/subscription',
        {},
        {
          headers: {
            'x-amzn-marketplace-token': token
          },
          withCredentials: true 
        }
      );

      if (response.status === 200) {
        const customerData = response.data;
        console.log('customerData:', customerData);
        this.props.awsCusData(customerData);
        
        //判斷是否進入註冊頁面
        const checkRegister = await axios.get(
          process.env.REACT_APP_API_URL + '/user/register/' + customerData.data.subscriptionId
        );

        if(checkRegister.data.exist === true){
            this.setState({
            status: 'exist_account',
            message: 'Thank you for subscribing to DigiFusion Platform via AWS Marketplace. Please visit to the registration system.',

          });
        } else {
          this.setState({
            status: 'success',
            message: 'Thank you for subscribing to DigiFusion Platform via AWS Marketplace. Please visit to the registration system.',
          });
        }
      } else {
        throw new Error('Authentication Failed');
      }
    } catch (err) {
      console.error('訂閱驗證失敗:', err);
      this.setState({
        status: 'error',
        message: 'Subscription failed. Please contact the support for assistance or reconfirm your subscription status.',
      });
    } finally {
      // 不論成功或失敗，都清除 URL 的 token
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("x-amzn-marketplace-token");
      window.history.replaceState({}, document.title, cleanUrl.pathname);
    }
  }

  handleRedirect = () => {
    const { status } = this.state;
    if(status === 'exist_account') {
      return (
        <>
          <Button type="primary" onClick={() => (window.location.href = process.env.REACT_APP_RETURN_WEB_URL)}>
            Official Website Home
          </Button>
        </>
          
      );
    } else {
      return (
        <>
          <Button type="primary" onClick={() => this.props.navigate('/client/register')}>
            Go to Registration System
          </Button>
        </>
      );
    }
  };

  renderContent() {
    const { status, message } = this.state;
    const { customer } = this.props;

    if (status === 'loading') {
      return (
        <div style={{ textAlign: 'center', paddingTop: '4rem' }}>
          <Spin size="large" tip={message}>
            <div style={{ height: '80px' }} />
          </Spin>
        </div>
      );
    }
    if (status === 'success' || status === 'exist_account' ) {
      return (
        <Result
          status="success"
          icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
          title="Subscription Authentication Success"
          subTitle={
            <>
              {message}
              <br />
              <b>Subscription Plan：</b>
              {customer?.dimension || 'Not provided'}
            </>
          }
          extra={this.handleRedirect()}
        />
      );
    }
    return (
      <Result
        status="error"
        icon={<CloseCircleTwoTone twoToneColor="#ff4d4f" />}
        title="Subscription Authentication Failed "
        subTitle={message}
        extra={
          <Button type="default" onClick={() => window.location.reload()}>
            Try Authentication Again
          </Button>
        }
      />
    );
  }

  render() {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <ClientHeader />
        <div style={{ flex: 1, maxWidth: 600, margin: '0 auto', padding: '2rem' }}>
          <Title level={2} style={{ textAlign: 'center' }}>
            AWS Marketplace Registration Authentication
          </Title>
          {this.renderContent()}
        </div>
        <ClientFooter />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
});

// 用 HOC 包裝 navigate 與 location（因為 class component 沒法用 hook）
export default connect(mapStateToProps, { awsCusData })(withRouter(LandingPage));